import { DesignAspectRatio } from 'types'
import { Group } from './Types'
import { ASPECT_RATIOS, AspectRatioKey } from 'components/NewFileModal/Types'

export const GROUPS: Array<Group> = [
  {
    name: 'Social Media',
    aspectRatios: [
      'instagram-square-post',
      'instagram-story',
      'instagram-portrait-post',
      'instagram-landscape-post',
      'facebook-cover',
      'facebook-post',
      'facebook-profile-picture',
      'facebook-marketplace',
      'linkedin-profile-picture',
      'linkedin-post',
      'linkedin-banner',
      'whatsapp-sticker',
      'pinterest',
      'twitter-post',
      'twitter-profile-picture',
      'twitter-cover-image',
      'landscape-post',
      'portrait-post',
      'square-post',
    ],
  },
  {
    name: 'Marketplaces',
    aspectRatios: [
      'ebay',
      'poshmark',
      'depop',
      'mercari',
      'mercadolibre',
      'shopee',
      'lazada',
      'etsy',
      'vinted',
      'amazon',
      'shopify-square',
    ],
  },
  {
    name: 'Video',
    aspectRatios: [
      'instagram-reel',
      'tik-tok-post',
      'tik-tok-thumbnail',
      'youtube-channel-art',
      'youtube-profile-picture',
      'youtube-short',
    ],
  },
]

export const ASPECT_RATIOS_SEARCH_INDEX = Object.fromEntries(
  (Object.entries(ASPECT_RATIOS) as Array<[AspectRatioKey, DesignAspectRatio]>).map(([key, value]) => [
    key,
    [value.name, value.width, value.height, `${value.width}x${value.height}`].map(String),
  ]),
) as Record<AspectRatioKey, Array<string>>
